import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Dispatch } from '@/store'
import { createModal, useModalize } from '@/components/modalize/mui'
import { Button } from '@/components/button'
import Icon from '@/components/icon'
import { breakpoints, colors, fontWeights } from '@/styles'
import { showConfirmModal } from './confirm-payment-modal'

const Title = styled.h1`
  color: ${colors.regular};
  text-align: center;
  font-weight: ${fontWeights.bold};
  font-size: 26px;
  letter-spacing: -0.2px;
  line-height: 36px;
  margin: 28px 0 8px;

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    font-size: 24px;
    letter-spacing: -0.4px;
    line-height: 32px;
  }
`

const Description = styled.p`
  color: ${colors.mediumGrey};
  font-size: 16px;
  letter-spacing: -0.2px;
  line-height: 24px;
  text-align: center;
  margin: 0 0 32px;
  max-width: 320px;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
`

const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const TrashIcon = styled(Icon)`
  padding: 0 0 1px;
`

const IconWrapper = styled.div`
  color: #fc645b;
`

type DeleteProps = {
  paymentMethodId?: string
}

const DeletePayment: React.FC<DeleteProps> = ({ paymentMethodId }) => {
  const dispatch = useDispatch<Dispatch>()
  const { t } = useTranslation()
  const { close } = useModalize()
  const onDelete = async () => {
    const response = await dispatch.plans.deletePaymentMethod(paymentMethodId)
    if (!(response && 'error' in response)) {
      close()
      showConfirmModal({ type: 'delete' })
    }
  }
  const onCancel = () => {
    close()
  }
  return (
    <Container>
      <IconWrapper>
        <Icon id="warning_alert" width={64} height={64} />
      </IconWrapper>
      <Title>
        {t('l.settings.view.plan_settings.payment_method.delete.title', 'Delete Card Info?')}
      </Title>
      <Description>
        {t(
          'l.settings.view.plan_settings.payment_method.delete.text',
          "Are you sure you want to delete your card info? You can't undo this action."
        )}
      </Description>
      <ButtonContainer>
        <Button theme="delete" onClick={onDelete}>
          <TrashIcon id="trash" width={16} height={16} />
          {t('common.delete', 'Delete')}
        </Button>
        <Button onClick={onCancel}>{t('common.cancel', 'Cancel')}</Button>
      </ButtonContainer>
    </Container>
  )
}

export const showDeletePaymentModal = createModal(DeletePayment, {
  id: 'delete-payment-method',
  maxWidth: '540px',
  width: '100%',
  showClose: false,
  clickOutside: false
})
